import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_2 = { class: "me-3 big-text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("? ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = { class: "text-capitalize animated slow flash infinite" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isInProgress)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.message)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.message), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createTextVNode(" Are you sure you want to " + _toDisplayString(_ctx.operation ? _ctx.operation : _ctx.okText) + " ", 1 /* TEXT */),
                _createElementVNode("b", null, _toDisplayString(_ctx.name), 1 /* TEXT */),
                _hoisted_5
              ]))
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(`btn btn-xs btn-${_ctx.btnClass} me-2 text-capitalize`),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.performOperation()))
        }, [
          (_ctx.includeYes)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Yes, "))
            : _createCommentVNode("v-if", true),
          _createTextVNode(" " + _toDisplayString(_ctx.okText), 1 /* TEXT */)
        ], 2 /* CLASS */),
        _createElementVNode("button", {
          class: "btn btn-xs btn-outline-secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelOperation()))
        }, [
          (!!_ctx.cancelText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.cancelText), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "No"))
        ])
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createCommentVNode(" <i class=\"fas fa-trash-alt animated slow flash infinite me-1\"></i> "),
          _createElementVNode("b", _hoisted_11, _toDisplayString(_ctx.operation ? _ctx.operation : _ctx.okText) + " In Progress...", 1 /* TEXT */)
        ])
      ]))
}